/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import "./icon-DGn-d_zv.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/assistant/assistant-specialist-pill/assistant-specialist-pill.css.js
var c = r(":host{border:1px solid var(--pill-color);border-radius:.5em;padding:.2rem .4rem;display:contents}[part=container]{padding:inherit;border:inherit;border-radius:inherit;background-color:var(--color-bg-light);border-color:var(--pill-color);border:1px solid var(--pill-color);color:var(--pill-color);transform-origin:top;grid-template-columns:min-content 1fr;align-items:center;gap:.2rem;font-size:.6rem;transition:all .3s ease-in-out;display:inline-grid;position:relative;overflow:hidden}[part=container]:after{content:\"\";background:linear-gradient(100deg,#fff0 10%,#ffffff80 50%,#fff0 90%);animation:2s infinite shine;display:block;position:absolute;inset:0}ptc-ui-icon{grid-area:1/1/2/2;transition:opacity .3s ease-in-out}[part=done-icon],[part=error-icon]{opacity:0}:is(:host([status=done]),:host([status=error])) [part=container]{color:var(--color-bg-light);background:var(--color-positive);border-color:var(--color-positive);animation:pill-done var(--pill-done-duration,2s) 0s forwards}:is(:host([status=done]),:host([status=error])) [part=icon],:is(:host([status=done]),:host([status=error])) [part=error-icon]{opacity:0}:is(:host([status=done]),:host([status=error])) [part=done-icon]{opacity:1}:host([status=error]) [part=container]{background:var(--color-negative);border-color:var(--color-negative)}:host([status=error]) [part=error-icon]{opacity:1}:host([status=error]) [part=done-icon]{opacity:0}@keyframes pill-done{0%{transform:scale(1)}50%{transform:scale(1.2)}75%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(0)}}@keyframes shine{0%{transform:translate(-100%)}to{transform:translate(100%)}}"), l = class extends e(i) {
	constructor(...e) {
		super(...e), this.styles = c, this.status = "running", this.label = "", this.color = "var(--blue)", this.dataId = "", this._handleAnimationEnd = (e) => {
			e.animationName === "pill-done" && this.dispatchEvent(new CustomEvent("pill-done", {
				bubbles: !0,
				composed: !0
			}));
		};
	}
	connectedCallback() {
		super.connectedCallback(), this.shadowRoot.addEventListener("animationend", this._handleAnimationEnd);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.shadowRoot.removeEventListener("animationend", this._handleAnimationEnd);
	}
	_getStatusText() {
		return {
			running: "arbeitet…",
			done: "fertig!",
			error: "fehlgeschlagen!"
		}[this.status];
	}
	render() {
		return a`
            <div part="container" style="--pill-color: ${this.color}">
                <ptc-ui-icon part="icon" name=${this.icon}></ptc-ui-icon>
                <ptc-ui-icon part="done-icon" name="icon.status.success"></ptc-ui-icon>
                <ptc-ui-icon part="error-icon" name="icon.status.failed"></ptc-ui-icon>
                ${this.label} ${this._getStatusText()}
            </div>
        `;
	}
};
n([s({ reflect: !0 }), t("design:type", Object)], l.prototype, "status", void 0), n([s(), t("design:type", Object)], l.prototype, "label", void 0), n([s(), t("design:type", Object)], l.prototype, "icon", void 0), n([s(), t("design:type", Object)], l.prototype, "color", void 0), n([s({
	attribute: "data-id",
	reflect: !0
}), t("design:type", Object)], l.prototype, "dataId", void 0), l = n([o("ptc-ui-assistant-specialist-pill")], l);
//#endregion
export { l as t };

//# sourceMappingURL=assistant-specialist-pill-BBAriyDc.js.map